import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { OrdersList } from './OrdersList/OrdersList';
import { OrdersShow } from './OrdersShow/OrdersShow';

export const ordersResource: ResourceProps = {
  name: Resources.Orders,
  create: <></>,
  edit: <></>,
  list: OrdersList,
  show: OrdersShow,
};
